// Locale is derived from the first path segment and nothing else. There is
// deliberately no Accept-Language sniffing and no auto-redirect: hiding the
// English site from crawlers behind a language guess breaks indexing of both
// versions, and bilingual users end up trapped in a locale they didn't pick.

export const SUPPORTED_LOCALES = ['de'];
export const DEFAULT_LOCALE = 'en';

export function detectLocale(pathname) {
  const segment = String(pathname || '').split('/')[1] || '';
  const normalized = segment.toLowerCase();
  return SUPPORTED_LOCALES.includes(normalized) ? normalized : DEFAULT_LOCALE;
}

export function basenameForLocale(locale) {
  return locale === DEFAULT_LOCALE ? '' : `/${locale}`;
}

export function stripLocale(pathname) {
  const path = String(pathname || '/');
  const locale = detectLocale(path);
  if (locale === DEFAULT_LOCALE) return path || '/';
  const rest = path.slice(`/${locale}`.length);
  return rest === '' || rest === '/' ? '/' : rest;
}

export function pathForLocale(pathname, locale) {
  const bare = stripLocale(pathname);
  if (locale === DEFAULT_LOCALE) return bare;
  return bare === '/' ? `/${locale}` : `/${locale}${bare}`;
}
